<template>
  <Modal v-model="matchWarehouseModal" :title="$t('key1006079')" :mask-closable="false" @on-visible-change="matchWarehouseChange">
    <Form :label-width="100" @submit.native.prevent>
      <Row type="flex">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <FormItem :label="$t('key1006080')">
            <Select v-model="warehouseId" filterable style="width: 300px;">
              <Option v-for="item in platformWarehouseList" :value="item.warehouseId" :key="item.warehouseId">{{ item.warehouseName }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="matchWarehouseModal=false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="matchWarehouseBtn" :disabled="!warehouseId">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'matchWarehouseModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      matchWarehouseModal: false,
      platformWarehouseList: [],
      warehouseId: null,
      matchWarehouseType: null,
      detailsInfo: {},
    };
  },
  methods: {
    // 初始化数据
    initMatchWarehouseData(obj, type) {
      this.platformWarehouseList = [];
      this.matchWarehouseType = type;
      this.detailsInfo = obj;
      this.axios.get(api.get_ymsPlatformOrder_queryTemuWarehouse + obj.ymsPlatformOrderId).then((response) => {
        if (response.data.code === 0) {
          this.platformWarehouseList = response.data.datas || [];
        }
      });
      this.matchWarehouseModal = true;
    },
    // 确定按钮
    matchWarehouseBtn() {
      let query = {};
      let url;
      let list = this.platformWarehouseList.filter((item) => item.warehouseId === this.warehouseId);
      switch (this.matchWarehouseType) {
        // 平台订单
        case 'platformOrder':
          url = api.put_ymsPlatformOrder_updateOrderPlatformWarehouse;
          query = {
            platformWarehouseId: this.warehouseId,
            platformWarehouseName: list[0].warehouseName,
            ymsPlatformOrderId: this.detailsInfo.ymsPlatformOrderId
          };
          break;
          // 平台订单详情
        case 'platformOrderDetail':
          url = api.put_ymsDistributorPackageInfo_updateOrderPlatformWarehouse;
          query = {
            platformWarehouseId: this.warehouseId,
            platformWarehouseName: list[0].warehouseName,
            ymsPlatformOrderId: this.detailsInfo.ymsPlatformOrderId,
            ymsPlatformOrderPackageRelatedId: this.detailsInfo.ymsPlatformOrderPackageRelatedId,
          };
          break;
      }
      this.axios.put(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          this.matchWarehouseModal = false;
          this.$emit('updateData', true);
        }
      });
    },
    // 监听弹窗
    matchWarehouseChange(value) {
      if (!value) {
        this.platformWarehouseList = [];
        this.warehouseId = null;
        this.matchWarehouseType = null;
        this.detailsInfo = {};
      }
    }
  }
};
</script>

<style lang="less">

</style>
